import React, { useState } from "react";

import Individual from "../../../images/icons/Individual.svg";
import Company from "../../../images/icons/company.svg";
import Proprietorship from "../../../images/icons/Proprietorship.svg";
import PARTNERSHIP from "../../../images/icons/PARTNERSHIP.svg";
import Checked from "../../../images/icons/checkbox_ok.svg";
// import "./BusinessType.css";

const TypeGrid = ({
  profession,
  image,
  isSelected,
  onClickCards,
  selectedProfession
}) => {
  // const [style, setStyle] = useState("");
  const divStyle = {
    height: "142px",
    maxWidth: "165px",
    borderColor: "#00ACB8",
    backgroundColor: "#F3F3F3"
  };

  return (
    <>
      <div
        onClick={() => {
          onClickCards(profession);
        }}
        className={` cursor-pointer hover:border-green-600 border-style h-32 w-32 flex 
        justify-center flex-col items-center 
          lg:bg-white sm:w-40 sm:h-32 justify-self-center
          ${isSelected} ? "shadow-lg" : "" `}
        style={isSelected ? divStyle : {}}
      >
        <img src={image} alt="" className="w-12 h-12 mb-3" />
        <div className="text-sm">{profession}</div>
        <div style={{ position: "relative", top: "10px" }}>
          {isSelected && <img src={Checked} />}
        </div>
      </div>
    </>
  );
};
export default TypeGrid;
